import { css } from 'emotion'

export const VanityClasses = {
  whiteradar: css`
    background-image: url('./img/whiteradar.svg');
    background-repeat: no-repeat;
    background-position: 150% 50%;
    background-size: 70%;
  `
}